import React from "react";

import CategoryForm from "../Category/CategoryForm";
import SubCategoryForm from "../SubCategory/SubCategoryForm";
import TypeForm from "../Catalouge/type/TypeForm";

const FORMS = {
  category: CategoryForm,
  subcategory: SubCategoryForm,
  type: TypeForm,
};

// Full-surface slide-over that hosts an existing catalog form. The form runs
// in "embedded" mode (see each form's onDone/onCancel props): saving fires
// onSaved and cancelling fires onCancel, so we never leave the /catalog route.
// Esc is handled inside each form so it can run the unsaved-changes guard.
const EditorDrawer = ({ editor, onSaved, onCancel }) => {
  if (!editor) return null;
  const Form = FORMS[editor.entity];
  if (!Form) return null;

  return (
    <div className="cw-editor" role="dialog" aria-modal="true">
      {/* key forces a fresh mount per target so switching records doesn't
          reuse the previous form's loaded data/state. */}
      <Form
        key={`${editor.entity}-${editor.mode}-${editor.id ?? "new"}`}
        mode={editor.mode}
        embeddedId={editor.id}
        onDone={onSaved}
        onCancel={onCancel}
      />
    </div>
  );
};

export default EditorDrawer;
